<ng-container *transloco="let t; read:'permit.team.add'">
        <div class="last-used"
            [class.last-used--without-filter]="(isPremium$ | async) !== true"
            [class.last-used--panel-open]="filterPanelOpen || sortPanelOpen">
        <search-box class="last-used__search" (triggerSearch)="search($event)" [ngModel]="query" [placeholder]="t('searchLastUsed')">
        </search-box>
        <div class="last-used__row">
            <button class="last-used__clear" type="button" (click)="clearSearchResults()">{{ t("clearSearch") }}</button>
            <div class="last-used__controls">
                <button *ngIf="(isPremium$ | async) === true"
                    class="last-used__filter-button"
                    [class.last-used__filter-button--active]="filterPanelOpen"
                    type="button"
                    [attr.aria-expanded]="filterPanelOpen"
                    (click)="toggleFilterPanel()">
                    {{ t("filter") }}
                </button>
                <button class="last-used__sort-button"
                    [class.last-used__sort-button--active]="sortPanelOpen"
                    [class.last-used__sort-button--last-used]="sort === RecentTeamMemberSort.lastUsed"
                    [class.last-used__sort-button--colleagues]="sort === RecentTeamMemberSort.colleagues"
                    [class.last-used__sort-button--shared]="sort === RecentTeamMemberSort.sharedFromPremium"
                    [class.last-used__sort-button--name]="sort === RecentTeamMemberSort.name"
                    [class.last-used__sort-button--certificate]="sort === RecentTeamMemberSort.certificateExpirationDate"
                    [class.last-used__sort-button--descending]="sortByDescending"
                    type="button"
                    [attr.aria-expanded]="sortPanelOpen" (click)="toggleSortPanel()">
                    {{ t("sort.title") }}
                </button>
            </div>
        </div>
        <div class="last-used__overlay" *ngIf="filterPanelOpen || sortPanelOpen">
            <button class="last-used__overlay-backdrop" type="button" [attr.aria-label]="t('cancel')" (click)="closePanels()"></button>
              <div class="last-used__panel" [class.last-used__panel--sort]="sortPanelOpen"
                  [class.last-used__panel--sort-descending]="sortPanelOpen && sortByDescending" role="dialog" aria-modal="true">
                <div class="last-used__panel-content">
                    <ng-container *ngIf="filterPanelOpen">
                        <div class="last-used__checkbox" *ngIf="hasSharedFromPremiumMembers$ | async">
                            <ha-checkbox [(ngModel)]="includeSharedFromPremium" [ngModelOptions]="{standalone: true}"
                                        [label]="t('includeSharedFromPremium')">
                            </ha-checkbox>
                        </div>
                        <div class="last-used__checkbox" *ngIf="hasColleagueMembers$ | async">
                            <ha-checkbox [(ngModel)]="includeColleagues" [ngModelOptions]="{standalone: true}"
                                        [label]="t('includeColleagues')">
                            </ha-checkbox>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="sortPanelOpen">
                        <div class="last-used__panel-heading">{{ t("sort.title") }}</div>
                        <button class="last-used__sort-option last-used__sort-option--last-used" type="button" (click)="selectSort(RecentTeamMemberSort.lastUsed)" [class.last-used__sort-option--active]="sort === RecentTeamMemberSort.lastUsed">{{ t("sort.lastUsed") }}</button>
                        <button class="last-used__sort-option last-used__sort-option--colleagues" type="button" (click)="selectSort(RecentTeamMemberSort.colleagues)" [class.last-used__sort-option--active]="sort === RecentTeamMemberSort.colleagues">{{ t("sort.colleagues") }}</button>
                        <button *ngIf="(isPremium$ | async) === true" class="last-used__sort-option last-used__sort-option--shared" type="button" (click)="selectSort(RecentTeamMemberSort.sharedFromPremium)" [class.last-used__sort-option--active]="sort === RecentTeamMemberSort.sharedFromPremium">{{ t("sort.sharedFromPremium") }}</button>
                        <button class="last-used__sort-option last-used__sort-option--name" type="button" (click)="selectSort(RecentTeamMemberSort.name)" [class.last-used__sort-option--active]="sort === RecentTeamMemberSort.name">{{ t("sort.name") }}</button>
                        <button class="last-used__sort-option last-used__sort-option--certificate" type="button" (click)="selectSort(RecentTeamMemberSort.certificateExpirationDate)" [class.last-used__sort-option--active]="sort === RecentTeamMemberSort.certificateExpirationDate">{{ t("sort.certificateExpirationDate") }}</button>
                    </ng-container>
                </div>
                <div class="last-used__panel-actions">
                    <button class="last-used__panel-close" type="button" (click)="closePanels()">{{ t("close") }}</button>
                </div>
            </div>
        </div>
        <div class="loader" *ngIf="loading$ | async"></div>
        <ng-container *ngIf="(loading$ | async) === false">
            <pmt-stage-person *ngFor="let person of result$ | async" [person]="person" [permitId]="permitId" [role]="role" (createCertificate)="createCertificate($event)">
            </pmt-stage-person>
        </ng-container>
        <div class="last-used__floating-actions">
            <button class="last-used__floating-action last-used__floating-action--add"
                    [class.last-used__floating-action--close]="filterPanelOpen || sortPanelOpen"
                    type="button"
                    (click)="filterPanelOpen || sortPanelOpen ? closePanels() : addNew()"
                    [attr.aria-label]="filterPanelOpen || sortPanelOpen ? t('cancel') : t('addNew')"></button>
        </div>
    </div>
    <a [routerLink]="" class="load-more-link" *ngIf="(loading$ | async) === false && (recentTeamMembersFullyLoaded$ | async) === false" (click)="loadMore()" >{{t("loadMoreButton")}}</a>
</ng-container>
